import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ebzv5q77kr: FaireBrandEntity = {
  token: "b_ebzv5q77kr",
  type: "brand",
  name: "Lamare",
  avatarUrl:
    "https://cdn.faire.com/fastly/683f1e144e07abc3e4c0d40d6ddade2f7dde20ff25c414cceb40291ee8eacc4c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/317a740add75feeeb5f25800140ff89640d3bf9248a658bc6f05ee70573a6a1c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/683f1e144e07abc3e4c0d40d6ddade2f7dde20ff25c414cceb40291ee8eacc4c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/317a740add75feeeb5f25800140ff89640d3bf9248a658bc6f05ee70573a6a1c.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 25,
  isInsider: true,
  description:
    "Lamare was created in order to deliver a fresh outlook on planning and journaling. It is meant to inspire, uplift and get you pumped to get your goals. We hope our planners help your bring your dreams to life! ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:32.034Z",
    importedBy: "entity-db-cli",
  },
};
